import React, { useEffect, useRef } from 'react';

import $ from 'jquery';
import DataTable from 'datatables.net-dt';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import 'datatables.net-colreorder-dt';
import 'datatables.net-fixedheader-dt';
import 'datatables.net-keytable-dt';
import 'datatables.net-rowgroup-dt';
import 'datatables.net-scroller-dt';
import 'datatables.net-searchbuilder-dt';
import 'datatables.net-searchpanes-dt';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';

import { Box, Button } from '@mui/material';
import { AxiosInstanceLongTimeOut } from '@service/axios-instance';

interface TableExplorerProps {
  dbName: string | null;
  tableName: string;
  startDate?: string;
  endDate?: string;
  match_filters_dict?: Record<string, any>;
  layout_ops?: any; // Replace 'any' with a more specific type if possible
  modifier_cb?: (row: any) => void;
  set_table_instance_cb?: (table: any) => void;
  savefuncRef?: React.MutableRefObject<any>;
  visibleColumns?: string[];
  searchble?: boolean | null;
  maskedColumns?: string[];
  hideColumnFilters?: boolean;
  dataProcessor_cb?: (data: any[]) => Promise<any[]> | any[];
  order?: any[];
  columnOrder?: string[];
  headerContent?: React.ReactNode;
}

const TableExplorer: React.FC<TableExplorerProps> = ({
  dbName,
  tableName,
  startDate,
  endDate,
  match_filters_dict = {},
  layout_ops,
  modifier_cb,
  set_table_instance_cb,
  savefuncRef,
  visibleColumns,
  searchble,
  maskedColumns = [],
  hideColumnFilters = false,
  dataProcessor_cb,
  order,
  columnOrder = [],
  headerContent
}) => {
  const tableRef = useRef(null);
  const dataTableInstance = useRef(null);

  const modifierRef = useRef(modifier_cb);
  useEffect(() => {
    modifierRef.current = modifier_cb;
  }, [modifier_cb]);

  let fetch_data = false;

  let layout = {
    //top:{
    //  search: {
    //    placeholder: 'Filtro geral'
    //  },
    //},
    topStart: null,
    topEnd: null,

    // mantém o texto "Mostrando X de Y" embaixo à esquerda
    bottomStart: 'info',

    // joga pageLength + paginação para a linha de baixo
    bottomEnd: {
      pageLength: {
        menu: [10, 50, 100, 1000, 5000],
      },
      paging: {
        numbers: 10,
      },
    },
  }

  if (layout_ops != null) {
    layout = layout_ops;
  }

  useEffect(() => {
    if (savefuncRef) {
      savefuncRef.current = {
        getDataArray: () => { return dataTableInstance.current.rows().data().toArray(); },

        saveTable: async (allData) => {
          console.log("alldata!", allData);
          const requestURL = `/${tableName}/save_${tableName}?db=${dbName}`;

          try {
            console.log("calling the url");

            const response = await AxiosInstanceLongTimeOut.post(
              requestURL,
              allData,
              { withCredentials: true }
            );
            console.log("Saved!", response.data);
            return response.data;
          } catch (err) {
            console.error("Save error", err);
            throw err;
          }
        }
      };
    }
  }, [dbName, tableName, savefuncRef]);

  const fetchData = async () => {
    const request = {
      "start_date": startDate,
      "end_date": endDate,
      match_filters_dict: match_filters_dict,
    };


    //let request = {}
    console.log("REQUEST_EVENTS ", tableName);

    //console.log("REQUEST_EVENTS ", request.start_date, request.end_date);

    const config = { withCredentials: true };
    let requestURL = ""
    if (dbName != "") requestURL = "/" + tableName + "/get_" + tableName + "?db=" + dbName
    else requestURL = "/" + tableName + "/get_" + tableName

    console.log("requesting", requestURL)
    AxiosInstanceLongTimeOut.post(requestURL, request, config).then(async (response) => {
      let finalData = response.data;
      if (dataProcessor_cb) {
        finalData = await dataProcessor_cb(finalData);
      }
      process_data(finalData);
    })
      .catch((error) => {
        console.log(error)
      })
  };

  const handleExportCsv = () => {
    if (dataTableInstance.current) {
      // dispara o botão interno "CSV" do DataTables Buttons
      dataTableInstance.current.button('.buttons-csv').trigger();
    }
  };

  function process_data(data) {
    console.log("process_data", data);

    const dataArray = [];
    const columnsLabels = [];

    let allKeys: string[] = [];

    const hasData = Array.isArray(data) && data.length > 0;

    if (hasData) {
      const uniqueKeys = new Set();
      data.forEach(row => {
        if (row && typeof row === 'object') {
          Object.keys(row).forEach(key => uniqueKeys.add(key));
        }
      });
      allKeys = Array.from(uniqueKeys);
    } else if (visibleColumns && visibleColumns.length > 0) {
      // No data, but schema was passed by props
      allKeys = visibleColumns;
    } else {
      console.warn("No data and no visibleColumns – cannot infer table schema.");
      // You can either return or create an empty table with no columns
    }

    console.log("allKeys", allKeys);
    let usedKeys = visibleColumns && visibleColumns.length > 0
      ? visibleColumns
      : allKeys;

    if (columnOrder && columnOrder.length > 0) {
      usedKeys.sort((a, b) => {
        const idxA = columnOrder.indexOf(a);
        const idxB = columnOrder.indexOf(b);
        if (idxA !== -1 && idxB !== -1) return idxA - idxB;
        if (idxA !== -1) return -1;
        if (idxB !== -1) return 1;
        return a.localeCompare(b);
      });
    }



    for (const key of usedKeys) {
      columnsLabels.push({
        title: key,
        render: function (data, type, row, meta) {
          let outData = data;
          let sortData = data;
          if (key === 'stamp' && data) {
            try {
              const strData = String(data);
              const brDateMatch = strData.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:[,\s]+(.*))?/);
              
              if (brDateMatch) {
                // If the backend already returns DD/MM/YYYY, convert it to a numeric timestamp for correct sorting
                const [_, d, m, y, time] = brDateMatch;
                const isoStr = `${y}-${m}-${d}T${time ? time.trim() : "00:00:00"}`;
                const parsedDate = new Date(isoStr);
                if (!isNaN(parsedDate.getTime())) {
                   sortData = parsedDate.getTime();
                } else {
                   sortData = isoStr; // Fallback to ISO string
                }
                if (type === 'display') outData = strData;
              } else {
                // Otherwise try standard ISO parsing
                const dateStr = strData.includes('GMT') || strData.endsWith('Z') ? strData : strData + 'Z';
                const date = new Date(dateStr);
                if (!isNaN(date.getTime())) {
                  sortData = date.getTime();
                  if (type === 'display') outData = date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
                }
              }
            } catch (e) {
              console.error(e);
            }
          }
          if (maskedColumns.includes(key) && type === 'display') {
            if (data != "") outData = '*****';
          }
          if (type === 'display') {
            return $.fn.dataTable.render.text().display(outData);
          }
          if (type === 'sort' || type === 'type') {
            return sortData;
          }
          return outData;
        }

      });
    }

    console.log("columnsLabels", columnsLabels);


    if (hasData) {
      for (const d of data) {
        const row_data = [];
        for (const key of usedKeys) {
          let value = d[key];

          //if (maskedColumns.includes(key)) {
          //  value = "*****";
          //}

          if (value === undefined || value === null) value = "";
          row_data.push(value);
        }
        dataArray.push(row_data);
      }
    }


    const table = $(tableRef.current).DataTable(
      {
        autoWidth: false,
        responsive: true,
        scrollX: true,
        layout: layout,
        order: order || [[0, 'asc']],

        buttons: [
          'colvis',
          'copy',
          {
            extend: 'csv',
            charset: 'UTF-8',
            bom: true,
            customizeData: function (data) {
              for (let i = 0; i < data.body.length; i++) {
                for (let j = 0; j < data.body[i].length; j++) {
                  if (typeof data.body[i][j] === 'string' && data.body[i][j].match(/^[=+@-]/)) {
                    data.body[i][j] = "'" + data.body[i][j];
                  }
                }
              }
            }
          },
          {
            extend: 'excel',
            charset: 'UTF-8',
          },
          'pdf',
          'print'
        ],
        columnDefs: [
          {
            targets: '_all',
            searchable: (searchble != null) ? searchble : true,
          },
        ],

        // Localization
        language: {
          "url": "https://cdn.datatables.net/plug-ins/1.12.1/i18n/pt-BR.json"
        },

        columns: columnsLabels,
        data: dataArray,



        initComplete: function () {
          const api = this.api();
          dataTableInstance.current = api;
          api.columns().every(function () {

            if (searchble !== false && !hideColumnFilters) {

              /* eslint-disable @typescript-eslint/no-this-alias*/
              const column = this;

              // Create input element
              const input = document.createElement('input');
              input.placeholder = "filtro";
              input.className = 'table-column-filter';
              input.style.width = '100%'; // Adjust the width as needed

              // Prevent column sorting when clicking on filter input
              $(input).on('click', function (e) {
                e.stopPropagation();
              });

              // Append input to the header
              $(input).appendTo($(column.header()));

              // Event listener for user input
              $(input).on('keyup change', function () {
                if (column.search() !== this.value) {
                  column.search(this.value).draw();
                }
              });

            }

          });

          table.on('click', 'tr', function () {
            if (modifierRef.current != null) {
              console.log('clicked: ' + table.row(this).data());
              if (table.row(this).data() != undefined) {
                modifierRef.current(table.row(this));
              }
            }
          });
          if (set_table_instance_cb) {
            set_table_instance_cb(table);
          }
          dataTableInstance.current = table;

        },

      });

  }

  useEffect(() => {
    if (fetch_data == false) {
      fetch_data = true;
      fetchData();
    }
    return () => {
      if (dataTableInstance.current) {
        dataTableInstance.current.destroy();
        dataTableInstance.current = null;
      }
    };
  }, []);


  return (

    <Box sx={{ width: '100%', minWidth: '100%' }}>
      {/* Botão de exportar CSV */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 1,
        }}
      >
        <Box flexGrow={1} mr={2}>
          {headerContent}
        </Box>
        <Button
          variant="outlined"
          size="small"
          onClick={handleExportCsv}
        >
          Exportar CSV
        </Button>
      </Box>

      <table ref={tableRef} className="stripe hover display" style={{ width: '100%' }} />
    </Box>

  );
};



export default TableExplorer;

